import { text } from "express";

const daTranslation = {
    // Common
    language: "Dansk",

    // Navigation
    navigation: {
        overview: "Oversigt",
        solutions: "Løsninger",
        features: "Funktioner",
        pricing: "Priser",
        testimonials: "Testimonial",
        partners: "Partnere",
        login: "Log ind",
        dashboard: "Dashboard"
    },

    // Footer
    footer: {
        aboutUs: "Om os",
        resources: "Ressourcer",
        legal: "Juridisk",
        linkedIn: "LinkedIn",
        faq: "FAQ",
        customerSupport: "Kundesupport",
        contactUs: "Kontakt os",
        privacyPolicy: "Privatlivspolitik",
        termsConditions: "Vilkår & Betingelser",
        rights: "Alle rettigheder forbeholdes."
    },

    // Pricing page
    pricing: {
        title: "Priser",
        subtitle: "Find den rigtige plan for jeres behov",
        setupFee: "engangsopstillingsgebyr",
        bookMeeting: "Book et møde",
        features: {
            fast: "Hurtig og pålidelig",
            fastDesc: "Vi har gjort det hurtigt og pålideligt."
        },
        plans: {
            timeRegistration: {
                name: "Tidsregistrering",
                description: "Enkel og omkostnings- effektiv tidsregistreringsløsning",
                features: {
                    legalCompliance: {
                        title: "Juridisk overholdelse",
                        description: "EU & danske arbejdstidsregler"
                    },
                    automaticTracking: {
                        title: "Automatisk sporing",
                        description: "Præcis GPS-sporing, geofencing & mobil login"
                    },
                    userFriendly: {
                        title: "Brugervenlig grænseflade",
                        description: "Fungerer på alle enheder"
                    },
                    timePolicy: {
                        title: "Tidsregistreringspolitik",
                        description: "495 pr. kontrakt"
                    }
                }
            },
            drivingAllowance: {
                name: "Kørselsgodtgørelse",
                description: "Eliminer manuel registrering og sikr skattekompliant kørselsrefusion",
                features: {
                    gpsTracking: {
                        title: "GPS-baseret sporing",
                        description: "Automatisk præcis kilometerregistrering"
                    },
                    taxCompliance: {
                        title: "Skattemyndighedskompatibel",
                        description: "Beregninger i henhold til skatteregler"
                    },
                    accounting: {
                        title: "Regnskabsintegration",
                        description: "Eksporter data til økonomisystemer"
                    },
                    dashboard: {
                        title: "Administrationsdashboard",
                        description: "Overblik og godkendelsesprocesser"
                    }
                }
            },
            co2: {
                name: "Drivn CO₂",
                description: "Spor og reducer virksomhedens CO₂-aftryk",
                features: {
                    automatedCalc: {
                        title: "Automatiserede beregninger",
                        description: "Præcis CO₂-emissionssporing"
                    },
                    dashboard: {
                        title: "Realtidsdashboard",
                        description: "Visuelle analyser og overvågning"
                    },
                    esgCompliance: {
                        title: "ESG-overholdelse",
                        description: "Support til myndighedsrapportering"
                    },
                    integration: {
                        title: "Systemintegration",
                        description: "Fungerer med din eksisterende software"
                    }
                }
            },
            allInOne: {
                name: "Alt-i-én løsning",
                description: "Integrér tidsregistrering, kørselsgodtgørelse og CO₂-overvågning i én samlet platform",
                features: {
                    complete: {
                        title: "Komplet løsning",
                        description: "Alle moduler i én integreret pakke"
                    },
                    reporting: {
                        title: "Konsolideret rapportering",
                        description: "Kombinerede analyser og dashboards"
                    },
                    integration: {
                        title: "Virksomhedsintegration",
                        description: "Problemfri forbindelse til dine systemer"
                    }
                },
                popular: "Populær"
            }
        },
        perMonth: "/ måned",
        perContract: "pr. kontrakt"
    },

    // Plan names
    plans: {
        timeRegistration: "Tidsregistrering",
        drivingAllowance: "Kørselsgodtgørelse",


    },

    // Plan descriptions
    planDescriptions: {
        growth: "Vores mål er at strømline SMV-handel og gøre det nemmere og hurtigere end nogensinde for alle og overalt.",
        enterprise: "Vores mål er at strømline SMV-handel og gøre det nemmere og hurtigere end nogensinde for alle og overalt."
    },

    // Login page
    login: {
        title: "Log ind på din konto",
        email: "Din e-mail",
        emailPlaceholder: "navn@firma.com",
        password: "Adgangskode",
        passwordPlaceholder: "••••••••",
        rememberMe: "Husk mig",
        forgotPassword: "Glemt adgangskode?",
        loginButton: "Log ind"
    },

    // Contact Sales page
    contactSales: {
        title: "Kontakt salg"
    },

    // Features page
    features: {
        title: "Funktioner",
        subtitle: "Kraftfulde funktioner til din virksomhed",
        description: "Vi leverer værktøjer, der hjælper dig med at administrere din virksomhed effektivt."
    },

    // Overview page
    overview: {
        title: "Oversigt",
        subtitle: "Din virksomhed på et øjeblik",
        description: "Få et omfattende overblik over din virksomheds præstation."
    },

    // Home page
    home: {
        title: "Hjem",
        main: {
            title: {
                get: "Få",
                actionable: "handlingsorienterede",
                insights: "indsigter og værktøjer til medarbejdertransport"
            },
            subtitle: "Sig farvel til inkonsistente data af lav kvalitet fra medarbejderundersøgelser og byd velkommen til vores fuldautomatisere løsning til ubesværet at overvåge, analysere og optimere din virksomheds transportpåvirkning med realtidsdata",
            getStartedButton: "Kom i gang",
            learnMoreButton: "Læs Mere",
            dashboardAltDark: "Dashboard forhåndsvisning mørk tilstand",
            dashboardAltLight: "Dashboard forhåndsvisning lys tilstand"
        },
        // Add Danish translations for the overview section
        overviewSection: {
            app: {
                title: "Drivn App: Styrk dine medarbejderes miljøbevidste pendling",
                description: "Løft dine medarbejderes daglige pendling med Drivn App'en. Designet med enkelhed og bæredygtighed for øje, muliggør vores app ubesværet registrering og administration af medarbejdernes rejser. Spor CO2-aftryk, deltag i grønne initiativer og støt miljømål automatisk.",
                features: {
                    registration: {
                        title: "Problemfri registrering:",
                        text: "Tilmeld dig med din organisationskode på få sekunder."
                    },
                    noEngage: {
                        title: "Ingen behov for at interagere med appen:",
                        text: "Logger automatisk i baggrunden uden behov for input."
                    },
                    realTime: {
                        title: "Realtidsdata:",
                        text: "Se dine arbejdsrelaterede transportemissioner i realtid."
                    },
                    greenGoals: {
                        title: "Grønne mål:",
                        text: "Deltag i virksomhedsudfordringer og bidrag til bæredygtighedsmål."
                    }
                }
            },
            dashboard: {
                title: "Drivn Dashboard: Indsigtsfuldt overblik for bæredygtighed",
                description: "Overgå til gennemsigtig og automatiseret CO2-regnskab med Drivns Dashboard. Ledere får et omfattende overblik over virksomhedens transportemissioner og tendenser. Udnyt dataens kraft til at træffe strategiske beslutninger, opfylde overholdelseskrav og gå forrest inden for virksomhedsansvar.",
                features: {
                    aggregated: {
                        title: "Aggregerede data:",
                        text: "Få et fugleperspektiv over virksomhedens pendlingsdata."
                    },
                    compliance: {
                        title: "Forenklet overholdelse:",
                        text: "Værktøjer skræddersyet til at opfylde CSRD- og ESG-rapportering."
                    },
                    insights: {
                        title: "Handlingsorienterede indsigter:",
                        text: "Analyser tendenser og mål effektiviteten af grønne politikker."
                    },
                    engage: {
                        title: "Engager og uddan:",
                        text: "Få adgang til ressourcer for at fremme en bæredygtighedskultur."
                    }
                }
            },
            charts: {
                emissions: {
                    title: "{{totalEmissions}} kg",
                    subtitle: "CO₂-emissioner",
                    seriesName: "Emissioner",
                    yAxisLabel: "{{value}}kg"
                },
                commutes: {
                    subtitle: "Antal pendlerture",
                    seriesName: "Pendlerture"
                },
                transport: {
                    mostUtilized: "Mest anvendte transportmetode",
                    mostUtilizedValue: "Bil",
                    methods: {
                        car: "Bil",
                        bus: "Bus",
                        train: "Tog",
                        bike: "Cykel",
                        walking: "Gående"
                    },
                    tooltipFormat: "{{value}} km"
                },
                months: {
                    jan: "Jan",
                    feb: "Feb",
                    mar: "Mar",
                    apr: "Apr",
                    may: "Maj",
                    jun: "Jun"
                }
            }
        },
        // Features section
        featuresSection: {
            mainTitle: "Designet til bæredygtige virksomheder som din",
            mainDescription: "Hos Drivn fokuserer vi på at udnytte avancerede teknologier og kreativitet til at låse op for emissionsdata, der aldrig er set før",
            highQualityData: {
                title: "Højkvalitetsdata",
                description: "Eliminer menneskelige fejl og sikr højkvalitetsdata med vores fuldautomatisere sporing."
            },
            automated: {
                title: "100% automatiseret",
                description: "Vores mobilapp udnytter maskinlæring og adaptiv geofencing til automatisk at identificere og beregne emissioner fra arbejdsrelaterede pendlerture."
            },
            insights: {
                title: "Værdifulde indsigter",
                description: "Uddan dine medarbejdere i deres pendlervaner og relaterede emissioner."
            },
            compliance: {
                title: "Overholdelse",
                description: "Vores webbaserede adminpanel samler realtidsdata og hjælper dig med ubesværet at opfylde CSRD- og ESG-krav."
            }
        },
        // Products/Solutions section
        productsSolutions: {
            title: "Vores løsninger",
            subtitle: "Opdag hvordan Drivn automatiserer kilometersporing, sikrer overholdelse af regler og integreres problemfrit med din arbejdsgang.",
            products: {
                tracking: {
                    id: "tracking",
                    title: "Drivn CO₂-sporing",
                    description: "Drivn CO₂ er et innovativt og brugervenligt system, der hjælper virksomheder med at registrere, overvåge og reducere deres CO₂-aftryk. Med automatiseret dataindsamling gør Drivn CO₂ det let at dokumentere miljøpåvirkning og opfylde ESG-krav samt lovgivningsmæssige rapporteringsstandarder.",
                    bulletPoints: [
                        { title: "Automatiseret CO₂-beregning:", text: "Indsamler og analyserer data fra virksomhedens aktiviteter for at give en præcis CO₂-rapportering." },
                        { title: "Live-overblik over emissioner:", text: " Intuitivt dashboard med realtidsdata og visuelle analyser." },
                        { title: "Compliance & ESG-rapportering:", text: "Understøtter dokumentation til myndigheder, investorer og certificeringsordninger." },
                        { title: "Optimering af bæredygtighedsstrategier:", text: "Identificerer CO₂-tunge processer og foreslår effektive reduktionstiltag." },
                        { title: "Integration med eksisterende systemer:", text: "Nem opsætning og kompatibilitet med økonomi-, transport- og produktionssoftware." }
                    ],
                    additionalInfo: "Drivn CO₂ er designet til virksomheder, der ønsker at tage ansvar for deres klimaaftryk og samtidig optimere deres forretningspraksis. Med vores løsning kan du træffe datadrevne beslutninger, reducere omkostninger og styrke din virksomheds grønne profil."
                },
                driving: {
                    id: "compliance",
                    title: "Drivn Automatiseret Kørselsgodtgørelse",
                    description: "Drivn tilbyder en automatiseret løsning til kørselsgodtgørelse, der eliminerer manuel registrering og sikrer præcise beregninger i overensstemmelse med Skattestyrelsens regler. Med GPS-sporing og automatisk logning af kørte kilometer reducerer systemet administrative byrder og minimerer risikoen for fejl.",
                    bulletPoints: [
                        { title: "Automatisk kørselsregistrering :", text: "GPS-baseret registrering sikrer præcis dokumentation af kørte kilometer." },
                        { title: "Overholder skattemæssige krav:", text: "Systemet beregner og dokumenterer kørselsgodtgørelse i henhold til gældende lovgivning." },
                        { title: "Integration med regnskabssystemer:", text: "Eksportér data direkte til virksomhedens økonomisystem for enkel bogføring." },
                        { title: "Tidsbesparende løsning:", text: "Eliminerer behovet for manuelle kørselsregnskaber og reducerer administrativt arbejde." },
                        { title: "Brugervenlig mobil- og webplatform:", text: "Medarbejdere kan nemt godkende og indsende kørselsdata med få klik." },
                        { title: "Øget gennemsigtighed og kontrol:", text: "Ledere får et klart overblik over medarbejdernes erhvervsmæssige kørsel." }
                    ],
                    additionalInfo: "Med Drivn Automatiseret Kørselsgodtgørelse får virksomheder en pålidelig og skalerbar løsning, der sikrer korrekt registrering, reducerer tidsforbrug og gør det lettere at overholde lovgivningskrav."
                },
                timeRegistration: {
                    id: "integration",
                    title: "Drivn Tidsregistrering",
                    description: "Drivn tilbyder markedets mest brugervenlige og prisvenlige tidsregistreringssystem, der sikrer, at din virksomhed overholder arbejdstidsloven og skaber overblik over medarbejdernes arbejdstimer. Med en fuldt digital og automatiseret løsning gør Drivn tidsregistrering let for både medarbejdere og ledere, samtidig med at det beskytter virksomheden juridisk.",
                    bulletPoints: [
                        { title: "Lovpligtig tidsregistrering:", text: "Overholder EU's arbejdstidsdirektiv og danske regler for arbejdstid." },
                        { title: "Automatisk registrering:", text: "Nøjagtig logning af arbejdstimer med GPS, geofencing og mobil-login." },
                        { title: "Enkel brugerflade:", text: "Medarbejdere kan nemt registrere mødetider via smartphone, tablet eller desktop." },
                        { title: "Fuld fleksibilitet:", text: "understøtter faste skemaer, skiftehold og fleksible arbejdstider." },
                        { title: "Rapporter og løn integration", text: "Genererer overskuelige rapporter og kan integreres med lønsystemer." },
                    ],
                    additionalInfo: "Med Drivn får du et tidsregistreringssystem, der sparer tid, sikrer compliance og reducerer administrative byrder. Løsningen er velegnet til virksomheder i alle størrelser, der ønsker en effektiv og problemfri registrering af arbejdstid."
                }
            }
        }
    },

    // Contact page
    contact: {
        pageTitle: "Kontakt Support",
        title: "Kontakt os",
        description: "Har du et teknisk problem? Vil du give feedback om en beta-funktionalitet? Har du brug for detaljer om vores forretningsplan? Lad os høre fra dig.",
        email: "Din e-mail",
        emailPlaceholder: "navn@firma.com",
        subject: "Emne",
        subjectPlaceholder: "Emnet for dit problem",
        message: "Din besked",
        messagePlaceholder: "Indholdet af dit problem",
        submit: "Send besked"
    },

    // FAQ page
    faq: {
        pageTitle: "FAQ",
        title: "Ofte stillede spørgsmål",
        questions: {
            howItWorks: {
                question: "Hvordan virker Drivn?",
                answer: "Drivn anvender en mobil applikation, som medarbejdere kan downloade til deres smartphones. Appen bruger geofencing og maskinlæring til at skelne mellem personlig og arbejdsrelateret transport. Dette giver os mulighed for automatisk at levere præcise data om CO2-udledninger genereret under medarbejdernes pendling. Individuelle data vil være tilgængelige for medarbejderen direkte i applikationen, mens de samlede data vil blive vist via et dashboard i Drivns administrationspanel."
            },
            benefits: {
                question: "Hvad er fordelene ved at bruge Drivn?",
                bulletPoints: [
                    "Overholdelse: Drivn hjælper virksomheder med at overholde miljøregler ved at levere realtidsdata om CO2-udledninger.",
                    "Medarbejderengagement: Vores platform gør bæredygtig pendling til en venlig konkurrence blandt medarbejdere, hvilket fremmer en kultur med miljøvenlige praksisser.",
                    "Datadrevne indsigter: Drivn tilbyder værdifulde indsigter i pendlingsmønstre, så virksomheder kan træffe informerede beslutninger for en grønnere fremtid."
                ]
            },
            privacy: {
                question: "Hvordan beskyttes brugerens privatliv?",
                answer: "Vi tager brugernes privatliv alvorligt. Drivn overholder alle relevante databeskyttelseslove inden for EU, og brugerne har kontrol over deres data. Vi giver tydelige oplysninger om de data, vi indsamler, og hvordan de anvendes, og brugerne kan til enhver tid fravælge eller deaktivere positionssporing. Der indgås en databehandleraftale i overensstemmelse med EU-standarder og Datatilsynet mellem klienten og Drivn ved virksomhedens onboarding. Yderligere information kan findes i vores Privatlivspolitik og Brugersamtykke."
            },
            getStarted: {
                question: "Hvordan kan min virksomhed komme i gang med Drivn?",
                answer: "Det er nemt at komme i gang! Tag blot kontakt til vores team, og vi guider dig gennem opsætningsprocessen. Vi hjælper dig med at tilpasse appen til din organisation, yder træning til dine medarbejdere og sikrer en problemfri integration i dine bæredygtighedsinitiativer."
            },
            compliance: {
                question: "Kan Drivn hjælpe med overholdelse af regler?",
                answer: "Absolut. Drivn er designet til at hjælpe virksomheder med at opfylde lovmæssige krav, især i forbindelse med GHG Protocol: scope 3 kategori 7 emissioner (Medarbejderpendling)."
            },
            dataInsights: {
                question: "Hvor ofte leverer Drivn dataindsigt?",
                answer: "Drivn giver realtidsindsigt, hvilket giver virksomheder mulighed for at få adgang til realtidsdata og information om pendlingsmønstre og CO2-udledninger. Dette sikrer, at organisationer kan træffe rettidige beslutninger for at reducere deres miljøpåvirkning."
            },
            userExpectations: {
                question: "Hvad forventes fra brugeren for at udnytte Drivn-appen?",
                answer: "For at sikre en problemfri oplevelse og nøjagtig dataindsamling opfordres brugere (medarbejdere) til at følge disse retningslinjer:",
                steps: [
                    "Download og registrering: Brugere skal downloade Drivn-appen fra det angivne link og registrere sig ved hjælp af deres organisations unikke kode.",
                    "Aktivér positionstjenester: For at muliggøre præcis sporing skal brugere aktivere \"tillad altid\"-indstillingen for positionstjenester til Drivn-appen. Drivn bruger positionsdata ansvarligt og respekterer brugerens privatliv.",
                    "Herefter kræves der ingen yderligere interaktion fra brugerens side, dog er analyser og statistik tilgængelige for brugeren at se, hvis ønsket."
                ]
            },
            transportModes: {
                question: "Hvilke typer transportmetoder dækker Drivn?",
                answer: "Drivn dækker omfattende forskellige transportmetoder og sikrer en komplet analyse af din organisations CO2-fodaftryk. De understøttede metoder omfatter:",
                modes: [
                    "Bil: Uanset om det er en firmabil eller personlig bil, sporer Drivn CO2-udledninger forbundet med bilpendling.",
                    "Tog og metro: For medarbejdere, der bruger offentlig transport, registrerer Drivn nøjagtigt udledninger relateret til togtransport.",
                    "Gang og cykling: Drivn genkender bæredygtige transportformer, såsom gang og cykling, hvilket bidrager til et holistisk syn på din miljøpåvirkning.",
                    "Bus: Drivn inkluderer også bustransport i sine sporingsmuligheder.",
                    "Andre transportmetoder dækket: Færge, Sporvogn, Metro."
                ]
            }
        },
        userConsent: "Brugersamtykke"
    },

    // Forgot Password page
    forgotPassword: {
        pageTitle: "Glemt adgangskode",
        title: "Nulstil din adgangskode",
        subtitle: "Indtast din e-mail her, og vi sender dig en e-mail, hvor du kan nulstille din adgangskode.",
        email: "Din e-mail",
        emailPlaceholder: "navn@firma.com",
        resetButton: "Nulstil adgangskode",
        sending: "Sender nulstilling af adgangskode...",
        error: "Der opstod en fejl",
        tryAgain: "Prøv igen",
        checkEmail: "Tjek din e-mail! (Og spam)",
        goToLogin: "Gå til log ind"
    },

    // Not Found page
    notFound: {
        pageTitle: "404",
        title: "Side ikke fundet",
        subtitle: "Beklager, vi kunne ikke finde den side, du leder efter.",
        goHome: "Gå tilbage til forsiden",
        contactSupport: "Kontakt support"
    },

    termsAndConditions: {
        pageTitle: "Vilkår og betingelser"
    },

    privacyPolicy: {
        pageTitle: "Privatlivspolitik"
    },

    // Dashboard
    dashboard: {
        tabs: {
            analytics: "Analyse",
            employees: "Medarbejdere",
            departments: "Afdelinger",
            offices: "Kontorer",
            settings: "Indstillinger"
        },
        logout: "Log ud",
        organizationCode: "Organisationskode:",
        copied: "Kopieret til udklipsholder",
        loading: "Indlæser bruger...",
        notAdmin: {
            title: "Denne side er kun tilgængelig for administratorer",
            greeting: "Hej",
            message: "i øjeblikket er denne side kun tilgængelig for administratorbrugere. Hvis du burde have adgang til din organisations analyser,",
            contact: "kontakt din organisationsadministrator på",
            persist: "Hvis problemet fortsætter,",
            support: "kontakt support"
        },
        analytics: {
            emissions: {
                title: "CO₂-emissioner",
                unit: "kg",
                increased: "Du brugte {{value}} kg sammenlignet med sidste periode",
                decreased: "Du sparede {{value}} kg i denne periode",
                chart: {
                    downloadButton: "Download brugerdefineret CSV",
                    day: "Dag",
                    date: "Dato",
                    emission: "Emission",
                    total: "Total",
                    months: [
                        "Januar", "Februar", "Marts", "April", "Maj", "Juni",
                        "Juli", "August", "September", "Oktober", "November", "December"
                    ]
                }
            },
            commutes: {
                title: "Antal pendlerture",
                seriesName: "Pendlerture"
            }
        },
        employees: {
            title: "Alle Brugere",
            breadcrumb: {
                dashboard: "Dashboard",
                allEmployees: "Alle Medarbejdere"
            },
            tableHeaders: {
                user: "Bruger",
                userRole: "Brugerrolle",
                department: "Afdeling",
                status: "Status"
            },
            pagination: {
                showing: "Viser",
                of: "af",
                previous: "Forrige",
                next: "Næste"
            },
            loading: "Indlæser Medarbejdere...",
            employeeCell: {
                roles: {
                    owner: "Ejer",
                    administrator: "Administrator",
                    employee: "Medarbejder"
                },
                status: {
                    active: "Aktiv",
                    removed: "Fjernet"
                },
                noSelection: "Ikke Valgt",
                delete: "Slet"
            }
        }
    }
};

export default daTranslation;